import { Interest } from '@io/domain';

import { Component, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { ApIconComponent } from '@ap/icon';

@Component({
    selector: 'interests',
    standalone: true,
    styleUrls: ['./interests.component.scss'],
    imports: [ApIconComponent, DecimalPipe],
    templateUrl: './interests.component.html'
})
export class InterestsComponent {
    _interests: Interest[];

    @Input() set interests(interests: Interest[]) {
        this.setSortedInterests(interests);
    }

    private setSortedInterests(interests: Interest[]): void {
        this._interests = [...interests].sort((a, b) => (a.interestRate < b.interestRate ? -1 : 1));
    }
}
